import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useAuthState } from 'state/useAuthState';
import { PageLayout } from 'components/PageLayout';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { AccountContent } from './AccountContent';

export const Content = (): JSX.Element => {
  const { t } = useTranslation();
  const { user } = useAuthState();

  return (
    <>
      <Helmet>
        <title>{t('myAccount.title')}</title>
      </Helmet>
      <SimplePageLayout>
        {user && <AccountContent user={user} />}
      </SimplePageLayout>
    </>
  );
};

export const Account = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="AccountPage"
      data-testid="AccountPage"
      headerBarProps={{ action: '/', title: t('myAccount.title') }}
    >
      <Content />
    </PageLayout>
  );
};
